/* eslint-disable no-unused-vars */
// import { store } from 'redux/store';
import _ from 'lodash';
import moment from 'moment';

import { getDataPoints, getMoreInfoDataPoints } from '../../pages/settings/helper';

import StructureSelector from '../structure.selector';
import PipelineSelector from '../pipeline.selector';
import { getAllWorkOrdersAndInspections } from './all-work-order-inspection-for-site';
import EquipmentSelector from 'selectors/equipment.selector';

export const getSiteDetailInfo = async ({
  siteId = '',
  getDataFromCache = false,
  store,
  selectedTaskType = null
}) => {
  const { cache, picklists, jurisdictionNumbers, settings, structure, pipeline } = store;
  const {
    sitesMap = {},
    equipmentsMap = {},
    sitesLoading,
    sitesEquipmentsMap = {},
    equipments: cacheEquipments = [],
    sites: cacheSites = []
  } = cache;

  const { structure: cacheStructures, sitesStructuresMap = {}, structuresMap = {} } = structure;
  const { sitePipelineCountMap } = pipeline;

  const structureDisplayFields = settings?.settings?.['structureDisplayFields'] || '';
  const equipmentDisplayFields = settings?.settings?.['equipmentDisplayFields'] || '';
  const siteDisplayFields = settings.settings?.['siteDisplayFields'] || '';
  const { jurisdictionNumbersMap = {} } = jurisdictionNumbers;
  const { picklistsMap = {}, areaHierarchyTreeDataMap = {} } = picklists;

  const pipelines = await PipelineSelector?.getPipelineWithWO({ store });
  const {
    assignedTasksList: tasksList,
    newWorkRequestList,
    hseEvents,
    onDemandRecordList,
    newWorkOrderList
  } = selectedTaskType !== 'NewOrEditAsset'
    ? await getAllWorkOrdersAndInspections({
        siteId,
        getDataFromCache,
        getWorkRequestData: true,
        store,
        recordsCount: true,
        query: selectedTaskType
      })
    : {
        assignedTasksList: [],
        hseEvents: [],
        newWorkRequestList: [],
        onDemandRecordList: [],
        newWorkOrderList: []
      };
  const equipments =
    (sitesEquipmentsMap[siteId] || []).filter((id) => cacheEquipments[equipmentsMap[id]]) || [];
  const structures =
    (sitesStructuresMap[siteId] || []).filter((id) => cacheStructures[structuresMap[id]]) || [];

  const particularPipelines = pipelines.filter(
    (p) =>
      p?.fromSite === siteId ||
      p?.toSite === siteId ||
      p?.sites?.some((x) => x?.toLowerCase() === siteId) ||
      p?.wells?.some((x) => x?.toLowerCase() === siteId)
  );

  const parentSite = cacheSites[sitesMap[siteId]] || {};
  // const tasks = tasksList?.filter(
  //   (t) => t?.siteId === siteId || t?.relatedAssetId === siteId || t?.sites?.includes(siteId)
  // );
  const tasks = tasksList;

  const allDoneTasks = tasks.filter((task) => task?.status === 'Synced');
  const allNotDoneTasks = tasks.filter((task) => task?.status !== 'Synced');

  const allWorkOrders = tasks?.filter((x) => x.type === 'Work Order');
  const allDoneWorkOrders = allDoneTasks?.filter((x) => x.type === 'Work Order');
  const allNotDoneWorkOrders = allNotDoneTasks.filter((task) => task?.status !== 'Synced');

  const allInspections = tasks?.filter((x) => x.type === 'Inspection');
  const allDoneInspections = allDoneTasks?.filter((x) => x.type === 'Inspection');
  const allNotDoneInspections = allNotDoneTasks.filter((task) => task?.status !== 'Synced');

  const allChecks = tasks?.filter((x) => x.type === 'Check');
  const allDoneChecks = allDoneTasks?.filter((x) => x.type === 'Check');
  const allNotDoneChecks = allNotDoneTasks.filter((task) => task?.status !== 'Synced');

  const today = moment().format('YYYY-MM-DD');

  const isOverDue = allNotDoneTasks.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const isInspectionOverDue = allNotDoneInspections.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const isWorkOrderOverDue = allNotDoneWorkOrders.find((task) =>
    task.dueDate ? moment(task.dueDate).isBefore(today) : false
  );
  const isCheckOverDue = allNotDoneChecks.find((task) =>
    task.dueDate ? moment(task.nextDue).isBefore(today) : false
  );

  const { name, siteType, areaHierarchy, link, latitude, longitude } = parentSite;
  const status = picklistsMap[parentSite.status]?.value;
  const area = areaHierarchyTreeDataMap[areaHierarchy]?.title;
  const data = { ...parentSite, area, type: siteType };
  const { unit, distance, children, ...rest } = data;

  const dataPoints = getDataPoints(
    { ...data, type: data?.siteType },
    siteDisplayFields,
    'site',
    picklistsMap
  );

  const dataPointsMap = dataPoints.reduce((acc, curr) => {
    acc[curr.Id] = curr;
    return acc;
  }, {});
  dataPointsMap['Status'] = { value: status, title: 'Status' };

  const MoreInfoDataPoints = getMoreInfoDataPoints(
    { ...data, type: data?.siteType },
    'site',
    picklistsMap
  );
  const MoreInfoDataPointsMap = MoreInfoDataPoints.reduce((acc, curr) => {
    acc[curr.Id] = curr;
    return acc;
  }, {});
  MoreInfoDataPointsMap['Status'] = { value: status, title: 'Status' };

  const structureEquipmentMap =
    structures?.length > 0
      ? await StructureSelector.getStructuresWithWO({
          store,
          ids: structures
        })
      : [];

  const structureAllFieldData = structureEquipmentMap?.filter((x) => {
    return x?.siteId === siteId;
  });

  const siteTypeQueryCondition = !selectedTaskType
    ? true
    : selectedTaskType &&
      [
        'Check',
        'check',
        'Inspection',
        'inspection',
        'workOrder',
        'Work Order',
        'workRequest',
        'Work Request',
        'hseEvents'
      ].includes(selectedTaskType)
    ? false
    : true;

  // const { pvPsv } = store;
  // let equipmentIdsWithPSVAndVesselIds = [];
  // const { pvPsvMap = {} } = pvPsv;
  // for (let eqId of equipments) {
  //   const { pv = [], psv = [] } = pvPsvMap[eqId] || {};
  //   equipmentIdsWithPSVAndVesselIds = [...equipmentIdsWithPSVAndVesselIds, ...psv, ...pv];
  // }

  // const allPSVAndVesselsOfTheEquipment =
  //   equipmentIdsWithPSVAndVesselIds?.length > 0 && equipments?.length > 0 && siteTypeQueryCondition
  //     ? await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({
  //         store,
  //         equipmentIds: equipmentIdsWithPSVAndVesselIds,
  //         siteId,
  //         sitesListingPage: true
  //       })
  //     : [];

  const allEditEquipmentAssets =
    (equipments?.length > 0 || siteId) && siteTypeQueryCondition
      ? await EquipmentSelector.getAllEquipmentsThatIsEditedAndNewCreates({
          store,
          equipmentIds: equipments,
          siteId,
          sitesListingPage: true
        })
      : [];

  const equipmentAllFieldData = await EquipmentSelector.getEquipmentsWithAllTasks({
    store,
    equipmentIds: equipments,
    onlyTaskCount: true
  });

  // equipments?.map((equipment) => {
  //   // const { pv = [], psv = [] } = pvPsvMap[equipment] || {};
  //   // let psvSyncedEquipment = [];

  //   // for (let psvId of psv) {
  //   //   let found = allPSVAndVesselsOfTheEquipment?.filter((t) => {
  //   //     return (
  //   //       t?.equipmentId === psvId || t?.relatedAssetId === psvId || t?.equipments?.includes(psvId)
  //   //     );
  //   //   });
  //   //   if (found?.length > 0) {
  //   //     psvSyncedEquipment = [...psvSyncedEquipment, ...found];
  //   //   }
  //   // }

  //   let equipmentSyncedAndEditedTasks = allEditEquipmentAssets?.filter((t) => {
  //     return (
  //       t?.equipmentId === equipment ||
  //       t?.relatedAssetId === equipment ||
  //       t?.equipments?.includes(equipment)
  //     );
  //   });

  //   const equipmentsTasks = tasksList?.filter(
  //     (t) => t?.equipmentId === equipment || t.equipments?.includes(equipment)
  //   );

  //   const allOnDemandRecordCount = onDemandRecordList?.filter((t) => {
  //     return (
  //       t?.equipmentId === equipment ||
  //       t?.relatedAssetId === equipment ||
  //       t?.equipments?.includes(equipment)
  //     );
  //   });

  //   const allDoneTasks = equipmentsTasks?.filter((task) => task?.status === 'Synced');
  //   const allNotDoneTasks = equipmentsTasks?.filter((task) => task?.status !== 'Synced');
  //   const today = moment().format('YYYY-MM-DD');
  //   const isOverDue = allNotDoneTasks?.find((task) =>
  //     task?.dueDate ? moment(task?.dueDate).isBefore(today) : false
  //   );

  //   const equData = cacheEquipments[equipmentsMap[equipment]] || {};
  //   const { jurisdictionNumber } = jurisdictionNumbersMap[equipment] || {};
  //   const dataPoints = getDataPoints(
  //     { ...equData, subtype: equData?.equipmentSubType, jurisdictionNumber },
  //     equipmentDisplayFields,
  //     'equipment',
  //     picklistsMap
  //   );

  //   return {
  //     ...equData,
  //     allDoneTasks,
  //     isOverDue,

  //     allTasksForSite: equipmentsTasks,
  //     allotDoneTasks: allNotDoneTasks,
  //     dataPoints,
  //     allOnDemandRecordCount: allOnDemandRecordCount?.length || 0,
  //     // equipmentSyncedAndEditedTasks: [...equipmentSyncedAndEditedTasks, ...psvSyncedEquipment],
  //     // onDemandEquipmentCount:
  //     //   equipmentSyncedAndEditedTasks?.length + psvSyncedEquipment?.length || 0,
  //     equipmentSyncedAndEditedTasks,
  //     onDemandEquipmentCount: equipmentSyncedAndEditedTasks?.length || 0
  //   };
  // });

  const parentSiteChildren = children?.map((childIndex) => {
    return { ...cacheSites[childIndex], children: [] };
  });

  return {
    sitesLoading,
    name,
    tasks: _.size(_.flattenDeep(tasks)) > 0 ? _.flattenDeep(tasks) : [],
    allDoneTasks: _.size(_.flattenDeep(allDoneTasks)) > 0 ? _.flattenDeep(allDoneTasks) : [],
    isOverDue,
    allWorkOrders: _.size(_.flattenDeep(allWorkOrders)) > 0 ? _.flattenDeep(allWorkOrders) : [],
    allDoneWorkOrders:
      _.size(_.flattenDeep(allDoneWorkOrders)) > 0 ? _.flattenDeep(allDoneWorkOrders) : [],
    allInspections: _.size(_.flattenDeep(allInspections)) > 0 ? _.flattenDeep(allInspections) : [],
    allDoneInspections:
      _.size(_.flattenDeep(allDoneInspections)) > 0 ? _.flattenDeep(allDoneInspections) : [],
    allChecks: _.size(_.flattenDeep(allChecks)) > 0 ? _.flattenDeep(allChecks) : [],
    allDoneChecks: _.size(_.flattenDeep(allDoneChecks)) > 0 ? _.flattenDeep(allDoneChecks) : [],
    allEditEquipmentAssets,
    isInspectionOverDue,
    isCheckOverDue,
    isWorkOrderOverDue,
    status,
    area,
    equipments,
    structures,
    dataPoints,
    unit,
    distance,
    children: parentSiteChildren,
    parentSite,
    rest,
    dataPointsMap,
    MoreInfoDataPointsMap,
    equipmentAllFieldData,
    structureAllFieldData,
    pipelines: particularPipelines,
    equipmentCount: sitesEquipmentsMap[siteId]?.length || 0,
    structureCount: sitesStructuresMap[siteId]?.length || 0,
    pipelineCount: sitePipelineCountMap[siteId]?.length || 0,
    link,
    newWorkRequestList,
    newWorkOrderList,
    newInspectionList: [],
    newChecksList: [],
    onDemandRecordList: onDemandRecordList?.length || 0,
    hseEvents,
    latitude,
    longitude
  };
};
